import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './ExpandableContent.module.scss';
import { withTranslation, WithTranslation } from 'next-i18next';
import { balanceHtmlTags, ellipsis, linkify, reactHtmlSafe } from '@/utils/string-util';

interface IState {
	isOpen: boolean;
}

interface IExpandableContentProps extends WithTranslation {
	content: string;
	shortLength?: number;
	onToggle?: (isOpen: boolean) => void;
	className?: string;
	contentClassName?: string;
	toggleClassName?: string;
	isLinkify?: boolean;
}

class ExpandableContent extends Component<IExpandableContentProps> {
	state: IState = {
		isOpen: false,
	};

	constructor(props: IExpandableContentProps) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	toggleExpanded() {
		this.setState({
			isOpen: !this.state.isOpen,
		});

		if (this.props.onToggle) {
			this.props.onToggle(!this.state.isOpen);
		}
	}

	render() {
		const {
			content,
			shortLength = 400,
			className,
			contentClassName,
			toggleClassName,
			isLinkify = false,
			t,
		} = this.props;

		const toggleClassNames = classNames(toggleClassName, styles.expandableContentToggle);

		const showLinks = isLinkify && content && (this.state.isOpen || content.length <= shortLength);

		const trimmedContent = this.state.isOpen ? content : balanceHtmlTags(ellipsis(content, shortLength, '...', false));

		const visibleContent = showLinks ? linkify(trimmedContent) : trimmedContent;

		return (
			<div className={className}>
				{visibleContent ? (
					<div key="content" className={contentClassName} dangerouslySetInnerHTML={reactHtmlSafe(visibleContent)}></div>
				) : null}
				{!this.state.isOpen && content && content.length > shortLength ? (
					<div key="button" className={toggleClassNames} onClick={this.toggleExpanded.bind(this)}>
						{t('read-more')}
					</div>
				) : null}
			</div>
		);
	}
}

export default withTranslation()(ExpandableContent);
